<template>
    <div class="scan-graphic d-flex flex-column justify-content-center align-items-center">
        <i v-if="scanIsBusy" class="fa-duotone fa-spinner fa-spin fa-10x text-primary"></i>
        <i v-else class="fa-duotone fa-scanner fa-10x"></i>
        <div class="display-4 mt-4 text-muted">Scan Package to Begin</div>
    </div>
</template>

<script>
    export default {
        name: 'appraisals-scan',
        data() {
            return {
                scanIsBusy: false,
            };
        },
        mounted() {
            this.$barcodeScanner.init((rawBarcode) => {
                this.$barcodeScanner.parseBarcode(rawBarcode, (barcode) => {
                    this.scanIsBusy = true;
                    this.$http.get('/scan/' + encodeURIComponent(barcode)).then((response) => {
                        this.$router.push({path: '/appraisals/process/' + response.data + '?scan='+(barcode)});
                    })
                        .catch((error) => {
                            this.scanIsBusy = false;
                            if (error.response && error.response.status === 404) {
                                this.$router.replace({ path: '/appraisals/not-found/' + this.$route.params.id });
                            }
                        });
                });
            });
        },
        beforeDestroy() {
            this.$barcodeScanner.destroy();
        },
    };
</script>

<style scoped>
    i {
        font-size: 18rem;
        color: gray;
    }

    .scan-graphic {
        height: 75vh;
    }
</style>
